/**
 * ProductTourHero Component
 * 
 * Tour detail hero section (başlık, breadcrumb, rating, meta bilgiler)
 */

'use client';

import Link from 'next/link';
import { motion } from 'framer-motion';
import { headerVariants } from '@/lib/animations';
import { ProductTourFormatterService } from '@/services/ProductTourFormatterService';
import { TourDuration } from '@/services/ProductTourDataService';
import { BreadcrumbItem } from '@/hooks/useProductBreadcrumbs';
import { useLanguageVariables } from '@/contexts/LanguageVariablesContext';

export interface ProductTourHeroProps {
    productName: string;
    breadcrumbs: BreadcrumbItem[];
    rating: number;
    reviewCount: number;
    tourDuration: TourDuration | null;
    groupSize: { min: number | null; max: number | null } | null;
    language?: string;
    /** Tur kodu / product_id – h1 önünde badge olarak gösterilir */
    productId?: string | number | null;
}

export default function ProductTourHero({
    productName,
    breadcrumbs,
    productId,
}: ProductTourHeroProps) {
    const { getVariable } = useLanguageVariables();
    const tourCodeLabel = getVariable('tour_detail.product_id', 'Tur Kodu');
 
    

    return (
        <motion.div className="flex flex-col gap-4 mb-12" variants={headerVariants}>
            <div className="flex flex-wrap items-center gap-3">
                {productId != null && productId !== '' && (
                    <span
                        className="inline-flex items-center px-2.5 py-1 rounded text-xl font-medium text-alsero-dark-gray bg-[#f3cf3f] shrink-0"
                        title={tourCodeLabel}
                    >
                        {String(productId)}
                    </span>
                )}
                <h1 className="text-xl lg:text-4xl text-alsero-text-dark font-bold min-w-0">
                    {productName}
                </h1>
            </div>

            {/* Breadcrumb */}
            {breadcrumbs.length > 0 && (
                <ul className="flex flex-row gap-3 text-sm text-alsero-light-gray">
                    {breadcrumbs.map((crumb, index) => (
                        <li key={index} className="flex items-center gap-3">
                            {index > 0 && <span>/</span>}
                            <Link
                                href={crumb.link}
                                className={`hover:text-alsero-first transition-colors ${
                                    crumb.active ? 'text-alsero-dark-gray font-semibold' : ''
                                }`}
                            >
                                {crumb.title}
                            </Link>
                        </li>
                    ))}
                </ul>
            )}
        </motion.div>
    );
}

